angular.module('app').filter('moeda', function () {
    return function (input) {
        return input;
    };
});

angular.module('app').filter('integer', function () {
    return function (input) {
        return input;
    };
});

angular.module('app').filter('percentual', function () {
    return function (input) {
        return input;
    };
});

angular.module('app').filter('decimal', function () {
    return function (input) {
        return input;
    };
});


angular.module('app').filter("trust", ['$sce', function ($sce) {
    return function (htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    }
}]);

angular.module('app').filter("trusturl", ['$sce', function ($sce) {
    return function (url) {
        return $sce.trustAsResourceUrl(url);
    }
}]);

angular.module('app').filter('nl2br', function ($sce) {
    return function (input) {
        return $sce.trustAsHtml(input.replace(/\n/g, '<br>'));
    };
});